export const GET_TIRE_SIZE_BEGIN = "GET_TIRE_SIZE_BEGIN"
export const GET_TIRE_SIZE_SUCCESS = "GET_TIRE_SIZE_SUCCESS"